import { useState } from 'react';

const concepts = [
  {
    icon: 'ri-currency-line',
    tag: 'BAZA',
    title: 'Perechi Valutare',
    short: 'Înțelege EUR/USD, GBP/USD și alte perechi majore',
    content: 'O pereche valutară arată câte unități din moneda de cotare (a doua) sunt necesare pentru a cumpăra o unitate din moneda de bază (prima). Exemple: EUR/USD 1.0850 înseamnă că 1 Euro = 1.0850 Dolari. Perechile se împart în majore, minore și exotice.',
    color: '#4ecdc4',
    image: 'https://public.readdy.ai/ai/img_res/dffc02f702a21fa86afb85886425e8eb.jpg',
  },
  {
    icon: 'ri-bar-chart-box-line',
    tag: 'ANALIZA',
    title: 'Analiza Tehnică',
    short: 'Citește graficele și identifică tendințele pieței',
    content: 'Analiza tehnică studiază mișcările de preț din trecut pentru a prezice direcția viitoare. Utilizează grafice de tip candlestick, niveluri de suport și rezistență, indicatori tehnici (RSI, MACD, Moving Averages) și tipare de preț pentru a lua decizii de tranzacționare.',
    color: '#0f1419',
    image: 'https://readdy.ai/api/search-image?query=candlestick%20chart%20forex%20technical%20analysis%20trading%20screen%20RSI%20MACD%20indicators%20financial%20chart%20patterns%20green%20red%20candles%20dark%20background%20teal%20accent%20lines%20professional&width=600&height=400&seq=concept02&orientation=landscape',
  },
  {
    icon: 'ri-scales-3-line',
    tag: 'CAPITAL',
    title: 'Leverage și Margin',
    short: 'Gestionează capitalul și înțelege efectul de levier',
    content: 'Leverage-ul îți permite să controlezi o poziție mai mare decât capitalul tău actual. De ex: leverage 1:100 înseamnă că cu 100$ poți controla 10.000$. Margin-ul este suma blocată ca garanție. Atenție: leverage mărește atât profiturile cât și pierderile.',
    color: '#ffb5a7',
    image: 'https://readdy.ai/api/search-image?query=financial%20leverage%20margin%20trading%20balance%20scale%20risk%20reward%20concept%20calculator%20numbers%20warm%20beige%20background%20elegant%20minimal%20business%20finance%20visualization&width=600&height=400&seq=concept03&orientation=landscape',
  },
  {
    icon: 'ri-swap-line',
    tag: 'TRANZACȚII',
    title: 'Bid, Ask și Spread',
    short: 'Cum funcționează prețurile în Forex',
    content: 'Bid este prețul la care poți vinde, Ask este prețul la care poți cumpăra. Diferența dintre ele se numește spread și reprezintă costul tranzacției. Spread-ul variază în funcție de broker, perechea valutară și volatilitatea pieței.',
    color: '#4ecdc4',
    image: 'https://readdy.ai/api/search-image?query=forex%20bid%20ask%20spread%20trading%20terminal%20price%20quotes%20financial%20screen%20buy%20sell%20buttons%20clean%20modern%20interface%20warm%20neutral%20tones%20professional%20trading%20concept&width=600&height=400&seq=concept04&orientation=landscape',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    tag: 'UNITATE',
    title: 'Pip și Lot',
    short: 'Unitățile de măsură fundamentale în Forex',
    content: 'Un pip (point in percentage) este cea mai mică unitate de mișcare a prețului, de obicei 0.0001 pentru majoritatea perechilor. Un lot standard = 100.000 unități din moneda de bază. Există și mini-loturi (10.000) și micro-loturi (1.000) pentru investiții mai mici.',
    color: '#0f1419',
    image: 'https://readdy.ai/api/search-image?query=forex%20pip%20lot%20size%20calculation%20trading%20units%20measurement%20financial%20mathematics%20clean%20infographic%20style%20warm%20cream%20background%20teal%20elements%20educational%20concept&width=600&height=400&seq=concept05&orientation=landscape',
  },
  {
    icon: 'ri-trending-up-line',
    tag: 'PIATA',
    title: 'Bull & Bear Market',
    short: 'Înțelege direcția pieței',
    content: 'Un Bull Market (piață bullish) înseamnă trend ascendent — prețurile cresc constant. Un Bear Market (piață bearish) înseamnă trend descendent. Identificarea corectă a trendului este esențială — "the trend is your friend" este una din cele mai celebre reguli din trading.',
    color: '#ffb5a7',
    image: 'https://readdy.ai/api/search-image?query=bull%20bear%20market%20forex%20stock%20market%20trend%20upward%20downward%20minimal%20elegant%20financial%20concept%20warm%20background%20cream%20beige%20teal%20accents%20professional%20trading%20art&width=600&height=400&seq=concept06&orientation=landscape',
  },
];

export default function ConcepteBaza() {
  const [activeIdx, setActiveIdx] = useState(1);
  const active = concepts[activeIdx];

  return (
    <section id="concepte" style={{ background: '#f5f1e8' }} className="py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span
            className="inline-block text-sm font-semibold uppercase tracking-widest mb-4 px-4 py-1 rounded-full"
            style={{ background: 'rgba(78,205,196,0.15)', color: '#4ecdc4' }}
          >
            02 — Concepte de Bază
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold leading-tight mb-4"
            style={{ fontFamily: 'Playfair Display, serif', color: '#0f1419' }}
          >
            Concepte Fundamentale
            <br />
            pentru Începători
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Stăpânește vocabularul și conceptele esențiale înainte de a tranzacționa
          </p>
        </div>

        {/* Grid selectable */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-10">
          {concepts.map((c, i) => (
            <button
              key={i}
              onClick={() => setActiveIdx(i)}
              className={`p-4 rounded-2xl text-left transition-all duration-300 cursor-pointer border ${
                activeIdx === i
                  ? 'border-transparent shadow-md scale-105'
                  : 'border-transparent bg-white hover:bg-white hover:shadow-sm'
              }`}
              style={activeIdx === i ? { background: c.color, color: '#fff' } : { background: 'white' }}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg mb-3`}
                style={{ background: activeIdx === i ? 'rgba(255,255,255,0.25)' : 'rgba(78,205,196,0.1)' }}
              >
                <i className={`${c.icon} text-sm`} style={{ color: activeIdx === i ? '#fff' : '#4ecdc4' }}></i>
              </div>
              <p className={`text-xs font-semibold uppercase tracking-wider mb-1 ${activeIdx === i ? 'text-white/70' : 'text-gray-400'}`}>{c.tag}</p>
              <p className={`text-sm font-bold ${activeIdx === i ? 'text-white' : 'text-gray-800'}`}>{c.title}</p>
            </button>
          ))}
        </div>

        {/* Detail card */}
        <div
          className="rounded-3xl overflow-hidden grid grid-cols-1 lg:grid-cols-2"
          style={{ background: '#0f1419', minHeight: '340px' }}
        >
          <div className="p-10 flex flex-col justify-center">
            <div
              className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6 w-fit"
              style={{ background: 'rgba(78,205,196,0.15)', color: '#4ecdc4' }}
            >
              <i className={`${active.icon}`}></i>
              {active.tag}
            </div>
            <h3
              className="text-3xl font-bold text-white mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {active.title}
            </h3>
            <p className="text-gray-300 leading-relaxed text-base mb-6">
              {active.content}
            </p>
            <p className="text-sm font-medium" style={{ color: '#4ecdc4' }}>
              <i className="ri-arrow-right-circle-line mr-2"></i>
              {active.short}
            </p>
          </div>
          <div className="relative h-64 lg:h-auto">
            <img
              src={active.image}
              alt={active.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(15,20,25,0.5), transparent)' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
}
